import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import styles from './materials.styles'
import Section from '../../shared/section/section'
import Segment from '../../shared/segment/segment'
import Segments from '../../shared/segments/segments'
import Paper from 'pobble-components/dist/paper'
import Simon from '../../shared/pobblers/simon160px.jpg'
import Tom from '../../shared/pobblers/tom160px.jpg'
import Louise from '../../shared/pobblers/lou160px.jpg'
import Henry from '../../shared/pobblers/henry160px.jpg'
import PlayIcon from 'react-icons/lib/fa/play'
import QuestionIcon from 'react-icons/lib/fa/question'
import FileIcon from 'react-icons/lib/fa/file-text'
import documents from './materials.data.js'
import Button from 'pobble-components/dist/button'
import { URLS } from 'pobble-components/dist/setup'

const Materials = ({
  classes,
  onMount,
  pending,
  isSchoolLeaderInPobbleSchool
}) => {
  useEffect(
    () => {
      onMount()
    },
    [onMount]
  )
  return (
    !pending && (
      <div>
        <Paper className={classes.container}>
          <Section title="Customer Happiness team">
            <Segments>
              <Segment size={'L'} className={classes.first}>
                <div className={classes.island}>
                  <img src={Simon} alt="Simon" className={classes.img} />
                  <div className={classes.content}>
                    <strong>Simon Blower</strong>
                  </div>
                </div>
                <div className={classes.island}>
                  <img src={Louise} alt="Louise" className={classes.img} />
                  <div className={classes.content}>
                    <strong>Louise Robinson</strong>
                  </div>
                </div>
                <div className={classes.island}>
                  <img src={Tom} alt="Tom" className={classes.img} />
                  <div className={classes.content}>
                    <strong>Tom Garbutt</strong>
                  </div>
                </div>
                <div className={classes.island}>
                  <img src={Henry} alt="Henry" className={classes.img} />
                  <div className={classes.content}>
                    <strong>Henry Smith</strong>
                  </div>
                </div>
              </Segment>
              <Segment className={classes.ctas}>
                <Button
                  className={classes.cta}
                  tall
                  href="mailto:hello@pobble.com">
                  hello@pobble.com
                </Button>
                {isSchoolLeaderInPobbleSchool && (
                  <Button
                    className={classes.cta}
                    tall
                    href="https://calendly.com/pobble/pobble-customer-happiness-call"
                    target="_blank">
                    Book a call
                  </Button>
                )}
              </Segment>
            </Segments>
          </Section>
          <Section title="Get started here">
            <Segments>
              <Segment>
                <div className={classes.island}>
                  <div className={classes.icon}>
                    <PlayIcon />
                  </div>
                  <div className={classes.content}>
                    <strong>
                      <a
                        href="https://training.pobble.com"
                        target="_blank"
                        rel="noopener noreferrer">
                        Pobble Training
                      </a>
                    </strong>
                    <span>Online training programme</span>
                  </div>
                </div>
              </Segment>
              {isSchoolLeaderInPobbleSchool && (
                <Segment>
                  <div className={classes.island}>
                    <div className={classes.icon}>
                      <FileIcon />
                    </div>
                    <div className={classes.content}>
                      <strong>
                        <a
                          href={`${URLS.APP}/account/files/Action-Plan.pdf`}
                          target="_blank"
                          rel="noopener noreferrer">
                          Action plan
                        </a>
                      </strong>
                      <span>Embed Pobble effectively in your school</span>
                    </div>
                  </div>
                </Segment>
              )}
              <Segment>
                <div className={classes.island}>
                  <div className={classes.icon}>
                    <QuestionIcon />
                  </div>
                  <div className={classes.content}>
                    <strong>
                      <a
                        href="https://pobble.zendesk.com/hc/en-us"
                        target="_blank"
                        rel="noopener noreferrer">
                        Help centre
                      </a>
                    </strong>
                    <span>The answers to FAQs</span>
                  </div>
                </div>
              </Segment>
            </Segments>
          </Section>
          <Section title="Pobble Teacher Resources" className={classes.last}>
            <Segments>
              <Segment size={'M'}>
                <div>
                  <h5>Celebration materials</h5>
                  <ul className={classes.documents}>
                    {documents.celebration.map((doc, index) => (
                      <li key={index}>
                        <a href={doc.url}>{doc.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h5>For use in the classroom</h5>
                  <ul className={classes.documents}>
                    {documents.classroom.map((doc, index) => (
                      <li key={index}>
                        <a href={doc.url}>{doc.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </Segment>
            </Segments>
          </Section>
        </Paper>
      </div>
    )
  )
}

export default injectSheet(styles)(Materials)
